import styled from 'styled-components';

export const CreditsCountLabel = styled.span`
    text-align: right;
    margin-bottom: 10px;
`
